import React, { useState } from "react";
import { CheckCircle, Fingerprint, WarningCircle } from "@phosphor-icons/react";
import api from "@/lib/api";

const BTN = "border-2 border-black bg-black px-3 py-2 text-[11px] font-bold uppercase tracking-widest text-white transition-colors duration-100 hover:bg-emerald-700 disabled:opacity-40";

// Settings → Visitor IP check: the IP the platform records for you vs. your real public IP.
export function VisitorIpCheck() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const [{ data }, mine] = await Promise.all([
        api.get("/admin/ip-check"),
        fetch("https://api64.ipify.org?format=json").then((r) => r.json()).then((j) => j.ip).catch(() => null),
      ]);
      setD({ ...data, mine });
    } finally { setBusy(false); }
  };
  const match = d && d.mine && d.mine === d.recorded_ip;
  return (
    <section className="brut-card mb-6 p-4" data-testid="visitor-ip-check">
      <div className="flex flex-wrap items-center gap-2">
        <Fingerprint size={20} weight="bold" />
        <div className="mr-auto">
          <div className="font-chivo text-lg font-black uppercase tracking-tighter">Visitor IP check</div>
          <p className="text-xs text-zinc-600">Every lead and consent record keeps the visitor&apos;s real IP, read from Cloudflare. Fake IP headers a visitor sends are ignored.</p>
        </div>
        <button type="button" onClick={run} disabled={busy} className={BTN} data-testid="visitor-ip-check-run">{busy ? "Checking…" : "Check my IP"}</button>
      </div>
      {d && (
        <div className="mt-3 space-y-2 text-sm" data-testid="visitor-ip-check-result">
          <div><span className="label-mono">Recorded for you:</span> <b data-testid="visitor-ip-recorded">{d.recorded_ip}</b></div>
          <div><span className="label-mono">Your public IP:</span> <b data-testid="visitor-ip-mine">{d.mine || "couldn't look it up"}</b></div>
          {d.mine && (
            <div className={`flex items-center gap-2 border-2 px-2 py-1 text-xs font-bold ${match ? "border-emerald-700 bg-emerald-50 text-emerald-900" : "border-amber-600 bg-amber-50 text-amber-900"}`}
                 data-testid="visitor-ip-match" data-match={match ? "1" : "0"}>
              {match ? <CheckCircle size={16} weight="fill" /> : <WarningCircle size={16} weight="fill" />}
              {match ? "Match — leads record the visitor's real IP." : "These differ. If you're on a VPN or work network that's normal; otherwise send this box to support."}
            </div>
          )}
          <details className="text-xs">
            <summary className="label-mono cursor-pointer">Proxy chain it was read from</summary>
            <pre className="mt-1 whitespace-pre-wrap break-all bg-zinc-50 p-2 font-mono text-[11px]">{JSON.stringify(d.headers, null, 2)}</pre>
          </details>
        </div>
      )}
    </section>
  );
}
